import {
  Button,
  EyeIcon,
  EyeSlashIcon,
  Input,
  useCustomForm,
  useEffect,
  useState,
} from "@";
import { useSaveDriverMutation } from "../api/mutations/index.ts";
import DriverPermissionsSection from "./DriverPermissionsSection.tsx";
import {
  driverCreateSchema,
  driverDefaultValues,
  driverEditSchema,
} from "../lib/validation.ts";
import type { Driver, DriverFormValues } from "../types.ts";

interface DriverFormModalProps {
  editData: Driver | null;
  onSuccess: () => void;
}

const DriverForm = ({ editData, onSuccess }: DriverFormModalProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const { reset, errors, register, handleSubmit, isSubmitting, control } =
    useCustomForm(
      driverDefaultValues,
      editData?.id ? driverEditSchema : driverCreateSchema,
    );

  const { mutateAsync: saveDriverMutation } = useSaveDriverMutation();

  const submit = async (form: DriverFormValues) => {
    await saveDriverMutation({
      id: editData?.id || undefined,
      name: form.name,
      phoneNumber: form.phoneNumber || undefined,
      password: form.password || undefined,
      permissions: form.permissions,
    });
    reset(driverDefaultValues);
    onSuccess();
  };

  useEffect(() => {
    if (editData?.id) {
      reset({
        ...driverDefaultValues,
        name: editData.name,
        permissions: editData.driverPermission,
      });
    }
  }, [editData]);
  return (
    <form onSubmit={handleSubmit(submit)} className="p-2 md:p-5">
      <div className="grid gap-5 md:grid-cols-2 md:gap-10">
        <div className="space-y-3">
          <Input label="الاسم" error={errors.name} input={register("name")} />

          <Input
            placeholder={
              editData?.id ? "اترك الحقل فارغ اذا لا تريد تعديلة" : ""
            }
            label="رقم الجوال"
            error={errors.phoneNumber}
            star={editData?.id ? "no" : ""}
            input={register("phoneNumber")}
          />

          {/* Password */}
          <div className="relative">
            <Input
              label="كلمة المرور"
              error={errors.password}
              star={editData?.id ? "no" : ""}
              autocomplete="new-password"
              input={register("password")}
              type={showPassword ? "text" : "password"}
              placeholder={
                editData?.id ? "اترك الحقل فارغ اذا لا تريد تعديلة" : ""
              }
            />

            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="icon-style absolute end-0 top-[31px] rounded-2xl rounded-s-none"
            >
              {showPassword ? (
                <EyeSlashIcon className="h-6 w-6" />
              ) : (
                <EyeIcon className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>

        <DriverPermissionsSection control={control} />
      </div>

      <div className="mt-8">
        <Button isLoading={isSubmitting} type="submit" title="حفظ البيانات" />
      </div>
    </form>
  );
};

export default DriverForm;
